import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LIST_VIEW_LIMIT } from "../../../../constants";

export const useWorklistData = ({ url, facilityNumber, asyncThunk, selectData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activePage, setActivePage] = useState(1);
  const [offSet, setOffSet] = useState(0);
  const [sortType, setSortType] = useState("");
  const [sortBy, setSortBy] = useState({ column: null, direction: null });

  const patientList = useSelector(selectData);

  const buildPayload = useCallback(
    (queryParam) => ({
      url,
      method: "Get",
      queryParam,
    }),
    [url]
  );

  const fetchList = useCallback(
    (queryParam) => {
      dispatch(asyncThunk(buildPayload(queryParam)));
    },
    [dispatch, asyncThunk, buildPayload]
  );

  const loadInitial = useCallback(() => {
    fetchList({ offSet: 0, limit: LIST_VIEW_LIMIT, facilityNumber });
  }, [fetchList, facilityNumber]);

  const onRowClick = useCallback(
    (data) => {
      if (data) navigate(`/patients/${data.ne1Id}`);
    },
    [navigate]
  );

  const onSort = useCallback(
    (column, direction) => {
      if (!column || !direction) return;

      const desc = direction === "desc";
      const sortParam = `${column}:${desc ? "DESC" : "ASC"}`;

      setSortBy({ column, direction });
      setSortType(sortParam);

      fetchList({
        offSet: isNaN(offSet) ? 0 : offSet,
        limit: LIST_VIEW_LIMIT,
        facilityNumber,
        sort: sortParam,
      });
    },
    [fetchList, facilityNumber, offSet]
  );

  const onPageChange = useCallback(
    (page) => {
      const newOffset = page * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT;
      const safeOffset = newOffset < LIST_VIEW_LIMIT ? 0 : newOffset;

      setActivePage(page);
      setOffSet(safeOffset);

      fetchList({
        offSet: safeOffset,
        limit: LIST_VIEW_LIMIT,
        facilityNumber,
        sort: sortType || undefined,
      });
    },
    [fetchList, facilityNumber, sortType]
  );

  return {
    patientList,
    activePage,
    sortBy,
    loadInitial,
    onRowClick,
    onSort,
    onPageChange,
  };
};
